import { render, staticRenderFns } from "./CookiePrivacyPage.vue?vue&type=template&id=5a5f2dce&scoped=true&"
import script from "./CookiePrivacyPage.vue?vue&type=script&lang=js&"
export * from "./CookiePrivacyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5f2dce",
  null
  
)

export default component.exports